import React, { memo } from 'react'

const IconSearch = ({ color = "#FFFFFF", ...props }) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M12.5 12.5L17.25 17.25M14.25 7.5C14.25 11.2279 11.2279 14.25 7.5 14.25C3.77208 14.25 0.75 11.2279 0.75 7.5C0.75 3.77208 3.77208 0.75 7.5 0.75C11.2279 0.75 14.25 3.77208 14.25 7.5Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default memo(IconSearch);